<template lang='pug'>
div
  Loader(v-if='renderLoader', absolute)
  PageError(v-else-if='pageError.status', :type='pageError.type')
  .promo--detail(v-else, :style='`margin-bottom:${footerHeight}px`')
    BannerImage(:src='imageStyle', height='135')
    //- Main section includes details of deal
    Section(:title='promoDetail.title', subtitle='')
      Note(v-if='promoDetail.date_visibility') Berlaku sampai {{ formattedDate }}
      hr.mt-4.mb-3
      Alert.mb-3(
        v-if='promoDetail.highlight',
        :message='promoDetail.highlight',
        bgColor='#E1FFF1',
        textColor='#00A460'
      )
      .promo--detail__section__value.mt-2(v-if='promoDetail.type === "1"') 
        Title.taro--text(style='margin-right: auto') Rp{{ promoDetail.price_emoney }}
        Description.pepper--darker--text
          img.mr-1(src='../assets/images/ic-deals.png', width='20px')
        Description.pepper--darker--text(style='margin-top: -1px')
          b {{ promoDetail.remaining }} voucher
      .promo--detail__section__body(
        :style='bodyStyle',
        ref='sectionBodyContainer',
        @click='leanplumWebviewTrigger("link", $event)'
      )
        div(ref='sectionBody', v-html='promoDetail.detail')
      p.promo--detail__section__body-toggle(@click='showFullDesc = !showFullDesc', v-if='isOverflow') {{ descPrompt }}

    //- Include if deal has single merchant
    Section(title='', subtitle='Merchant', v-if='merchantType === "single"')
      Profile(
        :profile='merchantProfile',
        :clickable='promoDetail.merchants[0].show_merchant_stores',
        @click='$router.push(`location?promo_id=${$route.query.id}&merchant_id=${promoDetail.merchants[0].id}`)'
      )

    //- Include section if deal includes multiple merchants
    Section(title='', subtitle='Merchant', v-else-if='merchantType === "multiple"')
      template(v-slot:link) 
        p.promo--detail__section__body-toggle(@click='clickMultipleMerchant') Lihat Semua
      AvatarGroup.mt-3(:items='multiMerchant')

    //- Dynamic sections containing instructions
    Section(
      v-for='instruction in promoDetail.instructions',
      :key='instruction.code',
      title='',
      :subtitle='instruction.title',
      collapsable
    )
      .promo--detail__section__content(v-html='instruction.content')
      
    //- Footer for CTA button
    Footer(sticky, v-if='promoDetail.cta_title', ref='promoDetailFooter')
      Button(:text='promoDetail.cta_title', full, @click='clickCTA()')
</template>

<script>
import { mapGetters } from 'vuex';
import { formatDate } from '../helpers/utils';
import {
  Profile,
  Section,
  Alert,
  BannerImage,
  Note,
  Title,
  Description,
  Loader,
  PageError,
  AvatarGroup,
  Footer,
  Button,
} from '@ovo/ravier-vue';
import JSBridge  from '@/helpers/jsbridge';

export default {
  components: {
    Loader,
    PageError,
    Note,
    Description,
    BannerImage,
    Title,
    Profile,
    Section,
    Alert,
    AvatarGroup,
    Footer,
    Button,
  },
  data() {
    return {
      showFullDesc: false,
      isOverflow: false,
      showToggle: false,
      footerHeight: 0,
    };
  },
  computed: {
    ...mapGetters({
      promoDetail: 'getPromoDetail',
      renderLoader: 'getRenderLoader',
      pageError: 'getPageError',
    }),
    imageStyle() {
      return this.promoDetail.images && this.promoDetail.images.length > 0 ? this.promoDetail.images[0].large : '';
    },
    bodyStyle() {
      return this.showFullDesc ? { height: 'auto' } : {};
    },
    descPrompt() {
      return this.showFullDesc ? 'Persingkat Detil' : 'Lihat Semua';
    },
    formattedDate() {
      return formatDate(this.promoDetail.date_ended, 'long');
    },
    showSingleMerchant() {
      if (this.promoDetail.merchants) {
        return this.promoDetail.merchants.length === 1 ? true : false;
      }
      return false;
    },
    merchantType() {
      let type = 'no_merchant';
      if (this.promoDetail.merchants) {
        if (this.promoDetail.merchants.length === 1) type = 'single';
        else if (this.promoDetail.merchants.length > 0) type = 'multiple';
      }
      return type;
    },
    merchantProfile() {
      if (this.merchantType === 'single') {
        let note = '';
        
        // HOTFIX: INDOMARET - list of merchant_ids
        // [2729790, 2869857, 2994651, 3112063]
        if (['2729790', '2869857', '2994651', '3112063'].indexOf(this.promoDetail.merchants[0].id) !== -1) {
          note = 'Tersedia di semua lokasi';
        } else if (this.promoDetail.merchants[0].stores_count != 0) {
          note = `Tersedia di ${this.promoDetail.merchants[0].stores_count} lokasi`;
        }

        const merchantStoreLocation = {
          note:
            this.promoDetail.merchants[0].all_stores
              ? `Tersedia di semua lokasi`
              : 'Tersedia di lokasi yang berpartisipasi',
        };
        return { ...this.promoDetail.merchants[0], ...merchantStoreLocation };
      }
      return this.promoDetail.merchants[0];
    },
    multiMerchant() {
      const multiMerchantList = [];
      if (this.promoDetail.merchants) {
        this.promoDetail.merchants.forEach(merchant => {
          multiMerchantList.push({
            img: merchant.image,
            title: merchant.name,
          });
        });
      }
      return multiMerchantList;
    },
    tabReferrer() {
      return this.$route?.query?.tab_referrer || '';
    },
    eventReferrer() {
      let referrer =  this.$route?.query?.referrer || '';
      if (Array.isArray(referrer)) {
        referrer = referrer.join(', ');
      }
      return referrer;
    },
    merchantIdList() {
      return (this.promoDetail?.merchants || []).map(merchant => merchant.id).join();
    },
  },
  updated() {
    this.checkDescHeight();
  },
  mounted() {
    this.setPromoDetail();
  },
  methods: {
    async setPromoDetail() {
      await this.$store.dispatch('getPromoDetail', this.$route.query.id);
      this.checkDescHeight();
      this.checkFooterHeight();
      this.leanplumImpressionTrigger();
    },
    checkDescHeight() {
      if (this.$refs.sectionBody && this.$refs.sectionBodyContainer) {
        if (
          this.$refs.sectionBodyContainer.getElementsByTagName('img').length > 0 ||
          this.$refs.sectionBodyContainer.getElementsByTagName('iframe').length > 0
        )
          this.showFullDesc = true;
        else {
          if (this.$refs.sectionBodyContainer.clientHeight < this.$refs.sectionBody.clientHeight) {
            this.isOverflow = true;
          }
        }
      }
    },
    checkFooterHeight() {
      if (this.$refs.promoDetailFooter) {
        this.footerHeight = this.$refs.promoDetailFooter.$el.clientHeight;
      }
    },
    clickMultipleMerchant() {
      this.leanplumWebviewTrigger('multiple_merchants');
      this.$router.push(`merchants?id=${this.$route.query.id}`);
    },
    clickCTA() {
      this.leanplumWebviewTrigger('cta');
      window.location = this.promoDetail.cta_link;
    },
    leanplumImpressionTrigger() {
      const jsBridge = new JSBridge();
      const promo = {
        Promo_ID: this.promoDetail.id,
        Promo_Name: this.promoDetail.title,
        Tab_Name: this.tabReferrer,
        Merchant_id: this.merchantIdList,
        Source: this.eventReferrer,
      };
      jsBridge.leanplumWebviewTracker('impression/promo_page/promo_detail_page', {
        Trigger: 'Page Load',
        TriggerValue: 'See Product Detail Page',
        Product: this.promoDetail.id,
        Page: 'Product Detail Page',
        ...promo,
        Description: `Page Load - See Product Detail Page - ${this.promoDetail.id} - Promo Detail Page`,
      });
    },
    leanplumWebviewTrigger(message, event) {
      const jsBridge = new JSBridge();
      const promo = {
        Promo_ID: this.promoDetail.id,
        Promo_Name: this.promoDetail.title,
        Tab_Name: this.tabReferrer,
        Merchant_id: this.merchantIdList,
      };
      if (!event) {
        if (message === 'cta') {
          jsBridge.leanplumWebviewTracker('event/promo_detail_page/click_CTA', {
            Trigger: 'Button Click',
            TriggerValue: 'Click CTA button',
            Product: promo.Promo_ID,
            Page: 'Product Detail Page',
            ...promo,
            Description: `Button Click - Click CTA Button - "${promo.Promo_ID}" - Product Detail Page`,
          });
        } else if (message === 'multiple_merchants') {
        
          jsBridge.leanplumWebviewTracker('event/promo_page/click_all_merchants', promo);
        }
      } else if (event.target.tagName.toLowerCase() === 'a') {
        jsBridge.leanplumWebviewTracker('event/promo_page/click_link', promo);
      }
    },
  },
};
</script>
